<template lang="pug">
  .box
    .subbox
      vm-row.title(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
        span {{ $t('rfis.request_for_information') }}
      vm-row.sb(vm-w="12")
        vm-col.image-box(vm-type="flex" vm-w="1")
          .p-img-cont
            img.round-imagen(:src="rfi.customer && rfi.customer.company_logo || require('@/assets/default-user-image.png')")
        vm-col.customerbox(vm-w="8")
            b-form-group
              span.customer.rfi-project-name  {{ rfi.project && rfi.project.project_name  }}
            span.data <b>{{ $t('strings.customer') }}:</b> {{ rfi.customer && rfi.customer.name || '' }}
            br
            span.data <b>{{ $t('rfis.location') }}:</b> {{ rfi.project && rfi.project.location }}
            br
            span.data <b>{{ $t('rfis.requested_information') }}:</b> {{ rfi.requested_information }}
            br
            span.data <b>{{ $t('rfis.rfi_number') }}:</b> {{ rfi.rfi_number }}
            br
            span.data <b>{{ $t('rfis.type') }}:</b> {{ rfi.type_display }}
            br
            span.data <b>{{ $t('rfis.reference') }}:</b> {{ rfi.reference }}
            br
            span.data(v-if="rfi.revision") <b>{{ $t('rfis.revision') }}:</b> {{ rfi.revision && rfi.revision.revision_number }}
        vm-col(vm-justify="center", vm-align="center", vm-w="3")
          vm-row(vm-w=12)
            vm-button( icon="printer-outline" @click="printRfi(rfi.id)" type="flat")
            vm-button( icon="trash-outline" @click="deleteRfiConfirm(rfi.id)" type="flat" v-if="$auth.check('Admin')")
          div(vm-w=12)
            .data(style="font-size: 12px") <b>{{ $t('rfis.requested_date') }}:</b> {{ formatDate(rfi.requested_date) }}
            .data(style="font-size: 12px") <b>{{ $t('rfis.reply_date') }}:</b> {{ formatDate(rfi.reply_date) }}
      vm-row(vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-textarea(height="120px" :placeholder='$t("rfis.question_placeholder")' v-model="rfi.question" type="text" disabled :label='$t("rfis.question")')
      vm-row(vm-w=12 v-if="rfi && questionAttachments && questionAttachments.length > 0")
        vm-col(vm-w=10)
          b-form-group
            vm-button(:icon="!toggleQuestionAttachments ? 'eye-outline' : 'eye-off-outline'" @click="toggleQuestionAttachments = !toggleQuestionAttachments") {{ !toggleQuestionAttachments ? $t('strings.show_question_attachments') : $t('strings.hide_question_attachments') }}
      vm-row(vm-w=12 v-if="rfi && questionAttachments && questionAttachments.length > 0")
        vm-col(vm-w=10)
          b-form-group
            transition(name="down-fade")
              .gallery-container(v-if="toggleQuestionAttachments")
                file-card(:key="index" v-for="(item, index) in questionAttachments" :data="item" :thumbnail="item.thumb_url" @view="openViewer" :showDelete="false")
      vm-row(vm-w="12")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          b-form-group
            vm-textarea(height="120px" :placeholder='$t("rfis.answer_placeholder")' v-model="rfi.answer" type="text" :label='$t("rfis.answer")' :disabled="rfi.reply_date")
      vm-row(vm-w="12" v-if="!rfi.reply_date")
        vm-col(vm-justify="center", vm-align="center", vm-w=3)
            span {{ $t('rfis.attachment_answer') }}
        vm-col(vm-justify="center", vm-align="center", vm-w=9)
          b-form-group
            input(type="file" multiple name="files[]" @change="handleFileUpload")
      vm-row(vm-w=12 v-if="rfi && answerAttachments && answerAttachments.length > 0")
        vm-col(vm-w=10)
          b-form-group
            vm-button(:icon="!toggleAnswerAttachments ? 'eye-outline' : 'eye-off-outline'" @click="toggleAnswerAttachments = !toggleAnswerAttachments") {{ !toggleAnswerAttachments ? $t('strings.show_answer_attachments') : $t('strings.hide_answer_attachments') }}
      vm-row(vm-w=12 v-if="rfi && answerAttachments && answerAttachments.length > 0")
        vm-col(vm-w=10)
          b-form-group
            transition(name="down-fade")
              .gallery-container(v-if="toggleAnswerAttachments")
                file-card(:key="index" v-for="(item, index) in answerAttachments" :data="item" :thumbnail="item.thumb_url" @view="openViewer" :showDelete="false")
      vm-row(vm-w=12)
        vm-col(vm-w=10)
          b-form-group
            span.data <b>{{ $t('rfis.created_by') }}:</b> {{ rfi.user && rfi.user.name || '' }}
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w=2)
          div
            transition(name="slide-fade")
              vm-button(icon="save-outline" @click="updateRfi" :disabled="isEnabled" v-if="rfis_update_permission && !!this.rfi.answer") {{ $t('strings.save') }}
</template>

<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('Rfis')

export default {
  name: 'Rfi',
  props: {
    rfi: {
      type: Object
    }
  },
  components: {
    FileCard: () => import('@/components/aditionals/FileCard.vue')
  },
  data: () => ({
    defaultImage: '@/assets/user_image.jpg',
    isLoading: false,
    toggleAnswerAttachments: false,
    toggleQuestionAttachments: false,
    rfis_update_permission: true
  }),
  computed: {
    isEnabled () {
      return !!this.rfi.reply_date || this.isLoading
    },
    questionAttachments () {
      return this.rfi.attachments.length > 0 ? this.rfi.attachments.filter(e => e.is_rfi_question === 1) : []
    },
    answerAttachments () {
      return this.rfi.attachments.length > 0 ? this.rfi.attachments.filter(e => e.is_rfi_question === 0) : []
    }
  },
  created () {
    this.checkPermission()
  },
  methods: {
    ...mapActions([
      'editRfi',
      'printRfi',
      'deleteRfi'
    ]),
    async handleFileUpload ({ target }) {
      this.rfi.answerFiles = target.files
    },
    checkPermission (permission) {
      this.rfis_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'rfis.update') > -1
    },
    formatDate (date) {
      return moment(date).format('ll')
    },
    async updateRfi () {
      this.isLoading = true
      // this.rfi.reply_date = moment().format('YYYY-MM-DD HH:MM:SS')
      this.rfi.is_rfi_question = 0
      await this.editRfi(this.rfi)
      // this.$emit('update', { record: this.rfi})
      this.isLoading = false
    },
    openViewer (attachment) {
      this.$viewer.show({
        urlFile: attachment.file_url,
        mime: attachment.mime_type,
        name: attachment.filename,
        color: '#FFF'
      })
    },
    deleteRfiConfirm (rfi) {
      let t = this
      this.auxDeleteRfi = () => {
        t.deleteRfi(rfi)
        t.emptyRfi()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('rfis.delete_confirmation_rfi', { attribute: this.$t(this.rfi.rfi_number) }),
        accept: this.auxDeleteRfi
      })
    },
    emptyRfi () {
      this.$emit('empty')
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  margin: 10px 0 0 10px;
  background: white;
  padding: 20px 20px;
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
  .subbox {
    border: 1px solid #e4e3e3;
    padding: 30px 30px;
  }
}

.sb {
  display: flex;
  justify-content: space-between;
  flex-wrap: initial;
  .image-box {
    width: 80px !important;
    .p-img-cont {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      width: 60px;
      height: 60px;
      .round-imagen {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 2px solid white;
        background: #e4e4e4;
        border-radius: 50%;
        box-sizing: content-box;
      }
    }
  }
}
.title {
  font-size: 25px;
  padding-bottom: 30px;
  font-weight: bold;
  color: #777676;
}
.data {
  padding-bottom: 10px;
  font-size: .8rem;
  color: #7b7878;
}
.customerbox {
  padding-left: 15px;
}
.customer {
  font-weight: bold;
  font-size: 15px;
  color: #777676;
}
.gallery-container {
  padding: 20px 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr) );
  grid-gap: 15px;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(-6px);
  opacity: 0;
}

.down-fade-enter-active, .down-fade-leave-active {
  transition: all .3s ease;
}
.down-fade-enter, .down-fade-leave-to {
  transform: translateY(-6px);
  opacity: 0;
}
.rfi-project-name  {
  color:red;
  font-size: 22px;
}
</style>
